import { render } from "./successLogin.vue?vue&type=template&id=7c0c94f2"
import script from "./successLogin.vue?vue&type=script&lang=js"
export * from "./successLogin.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\webencusco\\Desktop\\projects vue3\\flawyer\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__